export const getDiscount = (
  brandDiscount?: number,
  productDiscount?: number,
  variationDiscount?: number,
) => {
  return Math.max(
    brandDiscount || 0,
    variationDiscount || 0,
    productDiscount || 0,
  );
};
